import { ActionDisabledCondition, IsEmbedable, UserAction } from '@mediahaven/shared';
import { ApiFragment, RecordType } from '@stylehaven/components';

/*  Generate embed code
 *  Available when:
 *   * Is published
 *   * Is Embeddable
 *   * It is NOT deleted
 *   * It is not a representation
 *
 *  Disabled when:
 *    Item is not public
 */
export function GetEmbedUserAction(record: ApiFragment): UserAction {
    const isPublished: boolean = record.isPublished();

    const isEmbeddableType = IsEmbedable(record);
    const isPublic: boolean = record.isPublic();
    const isDeleted: boolean = record.isDeleted();
    const isRepresentation: boolean = record.getRecordType() === RecordType.Representation;

    const availableConditions: boolean[] = [isPublished, isEmbeddableType, !isDeleted, !isRepresentation];
    const disableConditions: ActionDisabledCondition[] = [
        { condition: !isPublic, tooltip: 'embed.not-public', entitySpecificTooltip: true }
    ];

    const embedAction: UserAction = new UserAction(availableConditions, disableConditions);

    return embedAction;
}
